import { errors } from '../modules/formElErrors.js';

var el = {};

var input = {
	$this: '.field-input input, .field-textarea textarea',
	$parents: '.field-input, .field-textarea',
	bind() {
		$(input.$this).focusout(function (e) {
			var $this = $(this),
				$parent = $this.parents(input.$parents),
				val = $this.val().trim();
			$this.val(val.trim());
			if ($parent.hasClass('error-check') && val.length > 0) {
				errors.check.el($parent);
			}
		});
		$(input.$this).keyup(function () {
			var $this = $(this),
				$parent = $(this).parents(input.$parents),
				val = $this.val().trim();
			if ($parent.hasClass('has-error') && val.length > 0) {
				errors.check.el($parent);
			}
		});
		if (typeof tinymce != 'undefined') {
			for (var i = 0; i < tinymce.editors.length; i++) {
				tinymce.editors[i].on("focusout", function () {
					var $parent = $('textarea[name="' + $(this)[0].id + '"]').closest('.field'),
						content = $(this)[0].getContent(),
						val = $($.parseHTML(content)).text();
					if ($parent.hasClass('error-check') && val.length > 0) {
						errors.check.el($parent);
					}
				});
				tinymce.editors[i].on("keyup", function () {
					var $parent = $('textarea[name="' + $(this)[0].id + '"]').closest('.field'),
						content = $(this)[0].getContent(),
						val = $($.parseHTML(content)).text();
					if ($parent.hasClass('has-error') && val.length > 0) {
						errors.check.el($parent);
					}
				});
			}
		}
	},
	unbind: function () {
		$(input.$this).unbind('focusout');
		$(input.$this).unbind('keyup');
	}
}

var select = {
	$this: '.field-select select',
	$parents: '.field-select',
	bind() {
		$(select.$this).each(function () {
			var $this = $(this);
			if ($this.val() != null) {
				$this.parents('.select').removeClass('has-placeholder');
				$this.find('option.disabled').remove();
			}
		});
		$(select.$this).change(function () {
			var $this = $(this),
				$parent = $this.parents(select.$parents);
			if ($this.val() != null) {
				$this.parents('.select').removeClass('has-placeholder');
				$this.find('option.disabled').remove();
			}
			if ($parent.hasClass('error-check') && $this.val() != null) {
				errors.check.el($parent);
			}
		});
	},
	unbind: function () {
		$(select.$this).unbind('change');
	}
}

var checkbox = {
	$this: '.field-checkbox input',
	$parents: '.field-checkbox',
	bind() {
		$(checkbox.$this).change(function () {
			var $this = $(this),
				$label = $this.parents('label'),
				$parent = $this.parents(checkbox.$parents);
			if ($this.is(':checked')) {
				$label.addClass('is-active');
			} else {
				$label.removeClass('is-active');
			}
			if ($parent.hasClass('error-check') && $parent.hasClass('has-error')) {
				errors.check.el($parent);
			}
		});
	},
	unbind() {
		$(checkbox.$this).unbind('change');
	}
}

var radio = {
	$this: '.field-radio input',
	$parents: '.field-radio',
	$labels: '.field-radio label',
	bind() {
		$(radio.$this).change(function () {
			var $this = $(this),
				$label = $this.parents('label'),
				$parent = $this.parents(radio.$parents);
			$(radio.$labels).removeClass('is-active');
			if ($this.is(':checked')) {
				$label.addClass('is-active');
			}
			if ($parent.hasClass('error-check') && $parent.hasClass('has-error')) {
				errors.check.el($parent);
			}
		});
	},
	unbind() {
		$(radio.$this).unbind('change');
	}
}

var image = {
	$this: '.input-image input[type="file"]',
	$button: '.input-image button.fake-input',
	$parents: '.field-gallery',
	$image: '.input-image .image',
	bind() {
		$(image.$image).each(function () {
			if ($(this).attr('src') != '') {
				if ($(this).width() <= $(this).height()) {
					$(this).addClass('is-portrait');
				} else {
					$(this).addClass('is-landscape');
				}
				$(this).parents('.input-image').addClass('is-active');
			}
		});
		$(image.$button).click(function (e) {
			e.preventDefault();
			var $this = $(this),
				$parent = $this.parents('.input-image');
			$parent.find('input[type="file"]').click();
		});
		$('.input-image .remove-icon').click(function (e) {
			e.preventDefault();
			var $this = $(this),
				$parent = $this.parents('.input-image');
			$parent.find('input[type="file"]').val('');
			$parent.find('.image').removeClass('is-portrait').removeClass('is-landscape');
			$parent.removeClass('is-active');
			setTimeout(function () {
				var selected_img = $parent.find('.image');
				if ('undefined' != typeof selected_img.data('image_id')) {
					var image_id = selected_img.data('image_id');
					$parent.prepend('<input type="hidden" name="remove_image_ids[]" value="' + image_id + '" />');
					selected_img.removeAttr('data-image_id');
				}
				selected_img.attr('src', '');
				if ($this.parents(image.$parents).find('.is-active').length == 0) {
					// oh oh, no images make it required
					if ('undefined' != typeof $this.parents(image.$parents).attr('data-error')) {
						//console.log('required');
						var $this_parents = $this.parents(image.$parents);
						$this_parents.addClass('error-check');
						$this_parents.addClass('has-error');
						if ($this_parents.find('.field-label sup').length == 0) {
							$this_parents.find('.field-label').append(' <sup>*</sup>');
						}
						errors.check.el($this_parents);
					} else {
						//console.log('NOT required');
					}
				}
			}, 300);
		});
		const inputs = document.querySelectorAll(image.$this);
		for (const input of inputs) {
			input.addEventListener('change', (e) => {
				var $this = $(e.target),
					$parent = $this.parents('.input-image'),
					file = e.target.files[0],
					fileReader = new FileReader();
				// reset field errors
				$this.parents(image.$parents).removeClass('has-error');
				$parent.closest('.field').find('.image-error').removeClass('image-error');
				if ('undefined' != typeof file && file.size > customData.max_filesize) {
					$parent.addClass('image-error');
					$this.val('');
					errors.check.elPHP($parent.closest('.field'), customData.errors.max_filesize);
				} else {
					errors.check.el($this.closest('.field'));
					fileReader.onloadend = function () {
						// input.removeEventListener('change');
						$parent.find('.image').attr('src', fileReader.result);
						$parent.find('.image').removeClass('is-portrait').removeClass('is-landscape');
						$parent.find('.image').load(function () {
							if ($(this).width() <= $(this).height()) {
								$(this).addClass('is-portrait');
							} else {
								$(this).addClass('is-landscape');
							}
							$parent.addClass('is-active');
						});
					}
					if (file) {
						fileReader.readAsDataURL(file);
					} else {
						$parent.find('.image').attr('src', '');
						$parent.removeClass('is-active');
					}
					if ($this.parents(image.$parents).hasClass('has-error')) {
						errors.check.el($this.parents(image.$parents));
					}
				}
			});
		}
	},
	unbind() {
		$(image.$button).unbind('click');
		$('.input-image .remove-icon').unbind('click');
	}
}

var avatar = {
	$this: '.field-avatar input[type="file"]',
	$button: '.field-avatar button.fake-input',
	$parents: '.field-avatar',
	$image: '.field-avatar .avatar-image',
	bind() {
		$(avatar.$image).each(function () {
			if ($(this).attr('src') != '') {
				if ($(this).width() <= $(this).height()) {
					$(this).addClass('is-portrait');
				} else {
					$(this).addClass('is-landscape');
				}
				$(this).parents('.input-avatar').addClass('is-active');
			}
		});
		$(avatar.$button).find('.thumb, .plus-icon').hover(function () {
			$(this).parents('.fake-input').addClass('is-hover');
		}, function () {
			$(this).parents('.fake-input').removeClass('is-hover');
		});
		$(avatar.$button).find('.thumb, .plus-icon').click(function (e) {
			e.preventDefault();
			var $this = $(this),
				$parent = $this.parents('.input-avatar');
			$parent.find('input[type="file"]').click();
		});
		$(avatar.$button).find('.remove-icon').click(function (e) {
			e.preventDefault();
			var $this = $(this),
				$parent = $this.parents('.input-avatar');
			$parent.find('input[type="file"]').val('');
			$parent.find('.avatar-image').removeClass('is-portrait').removeClass('is-landscape');
			$parent.removeClass('is-active');
			$this.parents('.field-avatar').addClass('error-check has-error');
			setTimeout(function () {
				$parent.find('.avatar-image').attr('src', '');
				errors.check.el($this.parents('.field-avatar'));
			}, 300);
		});
		const inputs = document.querySelectorAll(avatar.$this);
		for (const input of inputs) {
			// input.removeEventListener('change');
			input.addEventListener('change', (e) => {
				var $this = $(e.target),
					$parent = $this.parents('.input-avatar'),
					file = e.target.files[0],
					fileReader = new FileReader();
				$this.parents('.field-avatar').removeClass('has-error');
				if ('undefined' != typeof file && file.size > customData.max_filesize) {
					$this.val('');
					errors.check.elPHP($this.closest('.field'), customData.errors.max_filesize);
				} else {
					errors.check.el($this.closest('.field'));
					fileReader.onloadend = function () {
						$parent.find('.avatar-image').attr('src', fileReader.result);
						$parent.find('.avatar-image').removeClass('is-portrait').removeClass('is-landscape');
						$parent.find('.avatar-image').load(function () {
							if ($(this).width() <= $(this).height()) {
								$(this).addClass('is-portrait');
							} else {
								$(this).addClass('is-landscape');
							}
							$parent.addClass('is-active');
						});
					}
					if (file) {
						fileReader.readAsDataURL(file);
					} else {
						$parent.find('.avatar-image').attr('src', '');
						$parent.removeClass('is-active');
					}
					if ($this.parents('.field-avatar').hasClass('has-error')) {
						errors.check.el($this.parents('.field-avatar'));
					}
				}
			});
		}
	},
	unbind() {
		$(avatar.$button).find('.thumb, .plus-icon').unbind('hover');
		$(avatar.$button).find('.thumb, .plus-icon').unbind('click');
		$(avatar.$button).find('.remove-icon').unbind('click');
	}
}

var datepicker = {
	bind() {
		if (typeof jQuery.ui != 'undefined' && typeof jQuery.ui.datepicker != 'undefined') {
			datepicker.helpers.localization();
			$('.input-datepicker input').datepicker({
				inline: false,
				showOtherMonths: true,
				dateFormat: customData.datepicker.date_format,
				maxDate: customData.datepicker.date_max,
				minDate: customData.datepicker.date_min,
				numberOfMonths: 1,
				hideIfNoPrevNext: true,
				onSelect: function (dateText, inst) {
					var $parent = $(this).parents('.field-datepicker');
					if ($parent.hasClass('has-error') && $(this).val() != '') {
						errors.check.el($parent);
					}
					datepicker.helpers.compare.startEndDate($(this), dateText);
					datepicker.helpers.compare.endStartDate($(this), dateText);
				}
			});
			$('.input-datepicker input').keyup(function () {
				var dateText = $(this).val().replace('/', '-');
				$(this).val(dateText).change();
			});
			$('.input-datepicker input').focusout(function () {
				var $this = $(this),
					dateText = $this.val(),
					date = dateText.split('-'),
					date = new Date(Number(date[2]), Number(date[1]) - 1, Number(date[0])),
					today = new Date(),
					nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
				if (date == 'Invalid Date') {
					dateText = '';
				} else if (date < today) {
					var dd = today.getDate(),
						mm = today.getMonth() + 1,
						yyyy = today.getFullYear();
					if (dd < 10) {
						dd = '0' + dd
					}
					if (mm < 10) {
						mm = '0' + mm
					}
					dateText = dd + '-' + mm + '-' + yyyy;
				} else if (date > nextYear) {
					var dd = nextYear.getDate(),
						mm = nextYear.getMonth() + 1,
						yyyy = nextYear.getFullYear();
					if (dd < 10) {
						dd = '0' + dd
					}
					if (mm < 10) {
						mm = '0' + mm
					}
					dateText = dd + '-' + mm + '-' + yyyy;
				}
				$this.val(dateText).change();
				datepicker.helpers.compare.startEndDate($this, dateText);
				datepicker.helpers.compare.endStartDate($this, dateText);
			});
		}
	},
	unbind() {
		if (typeof jQuery.ui.datepicker != 'undefined') {
			$('.input-datepicker input').datepicker("destroy");
		}
	},
	helpers: {
		compare: {
			startEndDate: function ($this, dateText) {
				if ($this.hasClass('start-date')) {
					var $endDate = $('.field-datepicker .end-date');
					if ($endDate.val() != '') {
						var startDate = $this.datepicker("getDate"),
							endDate = $endDate.datepicker("getDate");
						if (startDate > endDate) {
							$endDate.val(dateText).change();
						}
					} else {
						$endDate.val(dateText).change();
					}
				}
			},
			endStartDate: function ($this, dateText) {
				if ($this.hasClass('end-date')) {
					var $startDate = $('.field-datepicker .start-date');
					if ($startDate.val() != '') {
						var startDate = $startDate.datepicker("getDate"),
							endDate = $this.datepicker("getDate");
						if (startDate > endDate) {
							$startDate.val(dateText).change();
						}
					} else {
						var today = new Date();
						dateText = today.getDate() + '-' + today.getMonth() + '-' + today.getFullYear();
						$startDate.val(dateText).change();
					}
				}
			}
		},
		localization() {
			$.datepicker.regional['nl'] = {
				closeText: "Sluiten",
				prevText: "←",
				nextText: "→",
				currentText: "Vandaag",
				monthNames: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
				monthNamesShort: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
				dayNames: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
				dayNamesShort: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
				dayNamesMin: ["zo", "ma", "di", "wo", "do", "vr", "za"],
				weekHeader: "Wk",
				dateFormat: "dd-mm-yy",
				firstDay: 1,
				isRTL: false,
				showMonthAfterYear: false,
				yearSuffix: ""
			};
			$.datepicker.setDefaults($.datepicker.regional['nl']);
		}
	}
}

//

var conditional = {
	$this: '.field.conditional-logic',
	$dependency: '.field.conditional',
	$parent: '.field',
	bind() {
		$(conditional.$this).find('input, select, textarea').each(function () {
			var $this = $(this),
				$parent = $this.parents(conditional.$parent),
				type = $parent.data('conditional');
			conditional.helpers.checkConditional($parent, type);
		});
		$(conditional.$this).find('input, select, textarea').change(function () {
			var $this = $(this),
				$parent = $this.parents(conditional.$parent),
				type = $parent.data('conditional');
			conditional.helpers.checkConditional($parent, type);
		});
	},
	helpers: {
		checkConditional: function ($this, type) {
			switch (type) {
				case "muziekvorm":
					var $conditional = $(conditional.$dependency + '[data-conditional=' + type + ']');
					if ($this.find('select').val() == 'muziek') {
						$conditional.addClass('is-active');
						$('body').icons.init('.svg-icon', $conditional);
					} else {
						$conditional.removeClass('is-active');
					}
					break;
				default:
					break;
			}
		}
	},
	unbind() {
		$(conditional.$this).find('input, select, textarea').unbind('change');
	}
}

var submit = {
	$this: '.field-submit .fake-submit button',
	$remove: '.field-submit .button.is-remove',
	bind() {
		$(submit.$this).click(function (e) {
			e.preventDefault();
			$(this).parents('form').submit();
		});
		$(submit.$remove).click(function () {
			var message = $(this).data('message');
			if (window.confirm(message)) {
				//console.log('verwijder!');
				var $submit_container = $(this).closest('.field-submit');
				if ($submit_container.find('input[name="remove"]').length < 1) {
					var nonce = $submit_container.closest('form').find('input[name$="_nonce"]').prop('value');
					if ('undefined' != typeof nonce && '' != nonce) {
						$submit_container.append('<input type="hidden" name="remove" value="' + nonce + '" />');
						setTimeout(function () {
							$submit_container.find('input[name="remove"]').remove();
						}, 500);
					}
				}
			}
		});
	},
	unbind() {
		$(submit.$this).unbind('click');
	}
}

el.init = function () {
	input.bind();
	select.bind();
	checkbox.bind();
	radio.bind();
	image.bind();
	avatar.bind();
	datepicker.bind();
	conditional.bind();
	submit.bind();
}

el.destroy = function () {
	input.unbind();
	select.unbind();
	checkbox.unbind();
	radio.unbind();
	image.unbind();
	avatar.unbind();
	datepicker.unbind();
	conditional.unbind();
	submit.unbind();
}

export { el };
